import { Flex, Spacing, Text, Textarea } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { INVOICE_MESSAGE_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceMessageCharacterLimit'

import { useFormContext } from '../../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettingsDebounced } from '../../../../hooks/useTrackInvoicingSettingsDebounced'
import type { DocumentTypeSettingsFormSchema } from '../../types/documentTypeSettingsFormSchema'
import { DocumentTypeSettingsCharacterCount } from '../DocumentTypeSettingsCharacterCount'

interface DocumentTypeSettingsMessageProps {
  trackingSection: InvoicingSettingsSection
}

export const DocumentTypeSettingsMessage = ({ trackingSection }: DocumentTypeSettingsMessageProps): ReactElement => {
  const { t } = useTranslation()
  const { FormItem, watch } = useFormContext<DocumentTypeSettingsFormSchema>()

  const message = watch('message')

  const handleDebouncedMessageChange = useTrackInvoicingSettingsDebounced('Message typed', {
    section: trackingSection,
  })

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      <FormItem
        name="message"
        label={<Text weight="medium">{t('invoicing_settings.document_type_settings.default_message')}</Text>}
        render={({ field: { onChange, ...rest } }) => (
          <Textarea
            {...rest}
            maxLength={INVOICE_MESSAGE_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedMessageChange()
            }}
            placeholder={t('settings.organization.external_invoice.content.default_invoice_message.placeholder')}
            rows={2}
          />
        )}
      />
      <DocumentTypeSettingsCharacterCount length={message.length} limit={INVOICE_MESSAGE_CHARACTER_LIMIT} />
    </Flex>
  )
}
